function readValue({
  key,
  defaultValue,
  storage = globalThis.sessionStorage
}) {
  if (!storage) {
    console.warn(`Storage is not available. Skipping read for key: ${key}`);
    return;
  }
  try {
    const item = storage.getItem(key);
    if (item) {
      return JSON.parse(item);
    } else if (defaultValue) {
      storage.setItem(key, JSON.stringify(defaultValue));
      return defaultValue;
    }
  } catch (err) {
    console.warn("Failed to read local storage value. Falling back to non-JSON parsing or default value", err);
    return storage.getItem(key) || defaultValue;
  }
}
function writeValue({
  key,
  value,
  storage = globalThis.sessionStorage
}) {
  if (!storage) {
    console.warn(`Storage is not available. Skipping write for key: ${key}`);
    return;
  }
  try {
    const stringifyVal = JSON.stringify(value);
    storage.setItem(key, stringifyVal);
  } catch {
    if (typeof value === "string") {
      storage.setItem(key, value);
    } else {
      throw new Error(
        `Failed to write ${key} to storage. Provided value is not a string and is not serializable.`
      );
    }
  }
}
export {
  readValue as r,
  writeValue as w
};
//# sourceMappingURL=safeStorageUtils-cA7Apjm4.js.map
